import EditorSection from './EditorSection';

export default EditorSection;
